// @ts-check
/* ═══════════════════════ REISEBOK-FORORD (#20) ═══════════════════════
   Etter reisen: Claude leser hele dagboken og skriver et varmt forord
   til reiseboka — en kort fortelling som binder turen sammen. Brukes av
   PDF-eksporten i main.js; faller pent tilbake til ingen forord offline.

   Bruker /api/dest-chat (ikke-strømmende JSON). Krever nett.
   ═══════════════════════════════════════════════════════════════════════ */

import { DAYS } from './data.js';

const SYSTEM = `Du skriver forordet til en familie-reisebok for Robert, Margita og Nicholas, om deres tur til Canada og Alaska sommeren 2026 \
(Vancouver, Alaska-cruise med Celebrity Solstice, og biltur gjennom Rocky Mountains til Calgary). \
Skriv på norsk (bokmål), i FØRSTEPERSON FLERTALL («vi»), varmt og personlig — som et forord man leser år senere. \
4–7 setninger, ÉN sammenhengende paragraf. Bygg KUN på dagbok-innleggene du får — trekk fram noen ekte øyeblikk og en rød tråd, \
ikke list opp alt. Ikke dikt opp hendelser som ikke står der. Ingen overskrift, ingen emoji, ingen anførselstegn — bare selve forordet.`;

/**
 * Be Claude skrive et forord til reiseboka basert på alle dagbok-innlegg.
 * @param {any[]} entries  dagbok-innlegg (sortert kronologisk)
 * @returns {Promise<string|null>} forord-tekst, eller null ved feil/offline/for lite stoff
 */
export async function generateForeword(entries){
  if (!Array.isArray(entries) || entries.length < 2) return null;
  if (!navigator.onLine) return null;

  // Komprimer innleggene til en kompakt kontekst
  const digest = entries.map(e => {
    const day = (typeof e?.dayIdx === 'number' && DAYS[e.dayIdx]) ? DAYS[e.dayIdx] : null;
    const where = day ? `${day.d} – ${day.title}` : (e?.title || 'Innlegg');
    const text = (e?.text || '').replace(/\s+/g, ' ').trim().slice(0, 400);
    const who = e?.author ? ` [${e.author}]` : '';
    return text ? `• ${where}${who}: ${text}` : '';
  }).filter(Boolean).join('\n');

  if (!digest) return null;

  const userMsg = `Skriv forordet til reiseboka vår. Her er dagbok-innleggene:\n\n${digest}`;

  try {
    const r = await fetch('/api/dest-chat', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        system: SYSTEM,
        messages: [{ role: 'user', content: userMsg }],
      }),
    });
    if (!r.ok) return null;
    const json = await r.json();
    const text = Array.isArray(json?.content)
      ? json.content.filter(b => b.type === 'text').map(b => b.text).join('').trim()
      : (json?.text || '').trim();
    return text || null;
  } catch {
    return null;
  }
}
